<script>
    import KSInfiniteTree from './../arts/InfiniteTree/InfiniteTree.vue';
    import {Listeners} from "../../../../constants/listeners";
    import AdaptersDialog from "../../../../component/adapters/Dialog.vue";
    import {store} from "../../store";
    import RadioButton from "primevue/radiobutton";

    export default {
        data() {
            return {
                name: 'MoveKeysFromFilter',
                loading: false,
                error: null,
                pid: -1,
                filter: null,
                keys: 0,
                selectedTo: [],
                nodes: [],
                superTree: {},
                store: store,
            }
        },
        methods: {
            save() {
                let data = {to: this.pid, filter: this.filter, from: this.getSelectNode.id};
                if (this.keys === 0) {
                    data['ids'] = this.selectedTo;
                }

                if (!this.pid) {
                    this.error = this.$t('lang.cluster.choose_move_folder');
                    return false;
                }

                this.$emitter.emit(Listeners.CLUSTER_MOVE_KEYS, data);
                this.onClose();
            },
            onClose() {
                this.$emitter.emit(this.getListenerMoveKeysCloseId);
            }
        },
        computed: {
            getUid() {
                return this.store.getters.uid();
            },
            getSelectNode() {
                return this.store.getters.selectNode();
            },
            getApiUrl() {
                return sprintf(
                    '%s/clustering/node/%s/%s/by_filter?filter=%s',
                    this.$config.API_URL,
                    this.getUid,
                    this.getSelectNode.id,
                    this.filter
                );
            },
            filteredNodes() {
                return this.nodes.filter(n => {
                    return n.id !== -1 && n.id !== -2;
                });
            },
            getListenerMoveKeysOpenId() {
                return Listeners.CLUSTER_POPUP_MOVE_KEYS_FROM_FILTER_OPEN;
            },
            getListenerMoveKeysCloseId() {
                return Listeners.CLUSTER_POPUP_MOVE_KEYS_FROM_FILTER_CLOSE;
            },
        },
        mounted() {
            let self = this;

            this.$emitter.on(Listeners.CLUSTER_MOVE_KEYS_FROM_FILTER, data => {
                self.superTree = self.$parent.$_tree;

                self.filter = data.filter;
                self.selectedTo = data.selectedTo;

                self.keys = 0;
                if (data.allSelected) {
                    self.keys = 1;
                }
                self.$emitter.emit(self.getListenerMoveKeysOpenId);
            });

            this.$emitter.on(Listeners.CLUSTER_KEYS_MOVE_FOLDER, pid => {
                self.pid = pid;
            });
        },
        components: {
            'ks-infinite-tree': KSInfiniteTree,
            AdaptersDialog,
            RadioButton,
        }
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="getListenerMoveKeysOpenId"
        :listener-close-id="getListenerMoveKeysCloseId"
        :header="$t('lang.cluster.move_keys_by_flt')"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="$t('lang.main.btn.move')"
        :callback-on-hide="onClose"
    >
        <template #content>
            <div v-if="selectedTo.length > 0" class="formgroup-inline">
                <label>{{ $t('lang.cluster.select_folder') }}</label>
                <div class="field-radiobutton">
                    <RadioButton v-model="keys" inputId="only_selected" :value="0" />
                    <label for="only_selected">{{ $t('lang.cluster.only_selected', [selectedTo.length]) }}</label>
                </div>
                <div class="field-radiobutton">
                    <RadioButton v-model="keys" inputId="under_the_filter" :value="1" />
                    <label for="under_the_filter">{{ $t('lang.cluster.under_the_filter') }}</label>
                </div>
            </div>
            <div class="field">
                <label for="choose_move_folder" class="required">{{ $t('lang.cluster.choose_move_folder') }}</label>
                <ks-infinite-tree :tree="superTree" v-model:pid="pid" :node-disabled="[0,-3]" :focus="true"></ks-infinite-tree>
            </div>
        </template>
    </AdaptersDialog>
</template>
